import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList, TextInput } from 'react-native'

import { database } from '../database/firebase';
import { collection, doc, getDoc, setDoc, addDoc, query, orderBy, onSnapshot } from 'firebase/firestore';

const JsonUploader = (  ) => {

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    
    async function addTheDoc() {
      console.log("Database");
      console.log(data);
      
      await setDoc(doc(database, "Situaciones2", "situa_01"), data)


    }

    useEffect(() => {
        fetch('https://raw.githubusercontent.com/Lozamded/NoRepo-SomeJson/main/misrecursos/situa_01_v2.json')
          .then((response) => response.json())
          .then((json) => setData(json))
          .catch((error) => console.error(error))
          .finally(() => setLoading(false));
    }, []);
    

    return (
        <View >
          <Text> Subir json </Text>
          <Button
            title='Subir'
            onPress= { addTheDoc }
            onClick= { addTheDoc }
          />
        </View>
    );

}

export default JsonUploader